import React from 'react';
import styles from './Title.module.sass';

const Title = ({
    children,
    size, transform, weight, color, margin
}: Props) => {

    return <div className={`
        ${styles['title']}
        ${styles['title__transform--'+(transform||'inherit')]}
        ${styles['title__size--'+(size||'small')]}
        ${styles['title__weight--'+(weight||'normal')]}
        ${styles['title__color--'+(color||'primary')]}
        ${styles['title__margin--'+(margin||'none')]}
    `}>
        { children }
    </div>;
}

interface Props {
    children: any
    size?: 'xlarge' | 'large' | 'medium' | 'small' | 'xsmall' | 'inherit'
    transform?: 'uppercase' | 'capatilize' | 'lowercase' | 'inherit'
    weight?: 'bold' | 'semibold' | 'normal'
    color?: 'primary' | 'secondary' | 'inherit' | 'warning' | 'error'
    margin?: 'top' | 'none'
}

export default Title;